import { Draft } from "immer";
import { PricingStatusModel } from "./PricingStatusModel";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import PricingStatusState from "./PricingStatusState";

const initialState: PricingStatusState = {
    isLoading: true,
    isPendingVerification: false,
    isSearchBarOpen: false,
    isPdpSticky: false,
    pricingStatus: {
        customerCode: "",
        isProsPrice: "",
        branch: "",
        errorMessage: "",
        billStatus: "",
        
    },    
     getcustomerStatus:{
        uri: null,
        companyId: "",
        customerId: "",
        shipToId: "",
        contactId: "",
        contactEmail: "",
        customerDelete: "",
        shipToDelete: "",
        contactDelete: "",
        ccStorage: "",
        isActive: "",
        allowOrderPlacement: "",
        allowWebPayments: "",
        showCustomerStatusBanner: "",
        creditStatus: "",
        properties: {}
    }
    
};

const reducer = {
    "HomePage/GetPricingStatus": (draft: Draft<PricingStatusState>) => {
        draft.isLoading = true;
    },
    "HomePage/IsSeacrhBarOpen": (draft: Draft<PricingStatusState>) => {
        draft.isSearchBarOpen = true;
    },
    "HomePage/IsSeacrhBarClose": (draft: Draft<PricingStatusState>) => {
        draft.isSearchBarOpen = false;
    },
    "Homepage/DispatchCompletePricingStatus": (
        draft: Draft<PricingStatusState>,
        action: {
            pricingStatus: PricingStatusModel;
        },
    ) => {
        draft.isLoading = false;
        draft.isPendingVerification =
            action.pricingStatus &&
            action.pricingStatus.billStatus &&
            action.pricingStatus.billStatus.toLowerCase() === "n"
                ? true
                : false;
        draft.pricingStatus = action.pricingStatus;
    },
    "Custom/PdpSticky": (draft: Draft<PricingStatusState>, action: { result: any }) => {
        draft.isPdpSticky = action.result;
    },
    "Homepage/getcustomerStatus": (
        draft: Draft<PricingStatusState>,
        action: { result: any }
    ) => {
        draft.getcustomerStatus = action.result;
    },
    
};

export default createTypedReducerWithImmer(initialState, reducer);

